export default __webpack_public_path__ + "static/media/Attention2.161589d6.png";